module.exports = __webpack_public_path__ + "static/media/13 Innovative Teaching learning Microcontroller 2022-23.f0750b9f.pdf";